import { apiClient } from './client';
import type { Catalog, Product } from '../types';

export const catalogApi = {
  // Get full catalog (categories with products + cart info)
  getCatalog: () => apiClient.get<Catalog>('/catalog'),

  // Get single product details
  getProduct: (id: number) => apiClient.get<Product>(`/products/${id}`),
};
